import React, { useState, useEffect } from 'react';
import './Sidebar.css'; // Add styling for collapsed/expanded states
import { setGlobalState, useGlobalState } from '../state/index';

function Sidebar({ activeTab, setActiveTab, AcceleratedLearning }) {
  const news = require('../icons/news_white.png');
  const assessment = require('../icons/Assessment_white.png');
  const lion = require('../icons/LION.png');
  const result = require('../icons/Results_white.png');
  const assignment = require('../icons/Assigenments_white.png');
  const schedule = require('../icons/Schedule_white.png');
  const codes = require('../icons/codes_white.png');
  const help = require('../icons/help_white.png');
  const Accelerated_Learning = require('../icons/icon_accel.png');
  const hide = require('../icons/hide.png');
  const show = require('../icons/show.png');
  const ReportCard = require('../icons/TEKSReport.png');

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [HideTeksTracker, setHideTeksTracker] = useState(false);
useEffect(() => {
  const storedValue = sessionStorage.getItem('HideTeksTracker');
  let trackerValue = false; 

  if (storedValue) {
    const lowerValue = storedValue.toLowerCase();

    if (lowerValue === "false") {
      trackerValue = false;
    } else if (lowerValue === "true") {
      trackerValue = true;
    } else {
      try {
        trackerValue = JSON.parse(storedValue);
      } catch (e) {
        console.warn('Failed to parse HideTeksTracker:', storedValue);
        trackerValue = false;
      }
    }
  }

  setHideTeksTracker(trackerValue);
}, []);

  const handleClick = (e) => {
    const allTabs = e.target.closest('ul').querySelectorAll('li');
    allTabs.forEach((tab) => tab.classList.remove('active'));

    e.currentTarget.classList.add('active');
  };
  const handleClickToggle = () => {
    if (!isCollapsed) {
      document.querySelector(".main-content").classList.add('collapsedMain'); 
    } else {
      document.querySelector(".main-content").classList.remove('collapsedMain');
    }
  };

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      {/* Toggle Button */}
      <button className="toggle-button">
        <span onClick={() => { handleClickToggle(); setIsCollapsed(!isCollapsed); }}>
          <img
            src={isCollapsed ? show : hide} // Choose the correct icon
            alt={isCollapsed ? "Expand" : "Collapse"}
            width={16}
            height={16} 
          />
        </span>
      </button>

      <ul>
        {/* <li
          onClick={(e) => { handleClick(e); setActiveTab('news'); }}
          title={isCollapsed ? 'News' : ''}
        >
          <img src={news} height={28} width={28} />
          <span className="menu-text">News</span>
        </li>  */}

        <li
          className={activeTab == "assessments" ? `active` : ''}
          onClick={(e) => { handleClick(e); setActiveTab('assessments'); }}
          title={isCollapsed ? 'Assessments' : ''}
        >
          <img src={assessment} height={28} width={28} />
          <span className="menu-text">Assessments</span>
        </li>

        <li
          className={activeTab == "results" ? `active` : ''}
          onClick={(e) => { handleClick(e); setActiveTab('results'); }}
          title={isCollapsed ? 'Results' : ''}
        >
          <img src={result} height={28} width={28} />
          <span className="menu-text">Results</span>
        </li>

        <li
          className={activeTab == "lion" ? `active` : ''}
          onClick={(e) => { handleClick(e); setActiveTab('lion'); }}
          title={isCollapsed ? 'LION' : ''}
        >
          <img src={lion} height={28} width={28} />
          <span className="menu-text">LION</span>
        </li>

        <li
          onClick={(e) => { handleClick(e); setActiveTab('assignments'); }}
          title={isCollapsed ? 'Assignments' : ''}
        >
          <img src={assignment} height={28} width={28} />
          <span className="menu-text">Assignments</span>
        </li>

        <li
          onClick={(e) => { handleClick(e); setActiveTab('schedule'); }}
          title={isCollapsed ? 'Schedule' : ''} 
        >
          <img src={schedule} height={28} width={28} />
          <span className="menu-text">Schedule</span>
        </li>

        <li
          onClick={(e) => { handleClick(e); setActiveTab('codes'); }}
          title={isCollapsed ? 'Codes' : ''} 
        >
          <img src={codes} height={28} width={28} />
          <span className="menu-text">Codes</span>
        </li>

        {AcceleratedLearning && (
          <li
            onClick={(e) => { handleClick(e); setActiveTab('acceleratedLearning'); }}
            title={isCollapsed ? 'Accelerated Learning' : ''}
          >
            <img src={Accelerated_Learning} height={28} width={28} />
            <span className="menu-text">Accelerated Learning</span>
          </li>
        )}
        {!HideTeksTracker && (
        <li
          onClick={(e) => { handleClick(e); setActiveTab('reports'); }}
          title={isCollapsed ? 'Dashboard' : ''} 
        >
          <img src={ReportCard} height={36} width={30} />
          <span className="menu-text">TEKS Tracker</span>
        </li>
        )}
        <li
          onClick={(e) => { handleClick(e); setActiveTab('Support'); }}
          title={isCollapsed ? 'Support' : ''}
        >
          <img src={help} height={28} width={28} />
          <span className="menu-text">Support</span>
        </li>
      </ul>
    </div>
  );
}

export default Sidebar;
